import { useEffect, useState } from "react";
import { updateCategoriesForm } from "../../lib/actions";
import { useNavigate, useParams } from "react-router-dom";
import { FiUploadCloud } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import DropDownFilterPaginations from "../../components/GDropDownList/DropDownFilterPaginations";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";

export default function EditCategoiresUi({ categoriesData, categoryByIdData, inputsData, search }) {

    const nav = useNavigate();
    const {categoryId} = useParams();
    const [categoryIdData, setCategoryIdData] = useState(null)
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    useEffect(() => {
        setImage(categoryByIdData.logo);
        setCategoryIdData(categoryByIdData.category_parent_id);

        const lang = currentLang;
        const nameObj = categoryByIdData?.category_parent_name;
        if (lang && nameObj) {
                const text = (lang === "en" ? nameObj.en : nameObj.ar) ?? "";
                search(text);
        };

    }, [categoryByIdData])

    const onchange = (e) => {
        setCategoryIdData(e);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);

        const result = await updateCategoriesForm(categoryId, formData, navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImage(URL.createObjectURL(file));
        }
    };

    const handleDeleteImage = () => {
        setImage(null);
    };


    if ((categoriesData).length < 1 && Object.entries(categoryByIdData).length < 1) {
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#2F7A74" size="large" text="" textColor="" /></div> 
    };
    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "category" : "الفئة"}</label>
                    <DropDownFilterPaginations search={search} options={categoriesData} value={categoryIdData} onchange={onchange} defaultText={currentLang === "en" ? "Select the category (not require)" : "أختر الفئة (اختياري) "} paramkey="category_id" />
                </div>
                {categoryIdData &&
                    <div className="mb-4">
                        <label className="block text-white mb-2"> {currentLang === "en" ? "percentage fee" : "نسبة الربح"} </label>
                        <input
                            type="text"
                            defaultValue={categoryByIdData.discount_percentage}
                            name="discount_percentage"
                            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                            required
                            placeholder={currentLang === "en" ? "enter percentage fee" : "نسبة الربح"}
                        />
                    </div>
                }
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "name in arabic" : "الاسم باللغة العربية "} </label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData.name.ar}
                        name="name_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in arabic" : "أدخل الاسم باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "name in english" : "الاسم باللغة الانجيليزية "}</label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData.name.en}
                        name="name_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in english" : " أدخل الاسم باللغة الانجليزية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "description in arabic" : "الوصف باللغة العربية "} </label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData.description.ar}
                        name="description_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        
                        placeholder={currentLang === "en" ? "enter description in arabic" : "أدخل الوصف باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "description in english" : "الوصف باللغة الانجليزية "} </label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData.description.en}
                        name="description_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        
                        placeholder={currentLang === "en" ? "enter description in english" : "أدخل الوصف باللغة الانجليزية "}
                    />
                </div>
            </div>
            <div className="mb-4">
                    <label className="block text-white mb-6">{currentLang === "en" ? "photo" : "الصورة"}</label>
                    <div className="flex justify-center items-center">
                        <div className="bg-thirdly sm:w-[50%] w-[100%] p-6 rounded-2xl border-2 border-dashed border-gray-200">
                            {/* <label className="block text-sm font-medium text-gray-700 mb-4">الصورة الرئيسية</label> */}
                            <div className="relative group">
                                <div className={`flex flex-col items-center justify-center  h-48 ${!image ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                                    {!image ? (
                                        <>
                                            <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                                            <span className="text-sm text-white group-hover:text-secondary transition-colors">
                                               {currentLang === "en" ? "click to upload a photo" : " انقر لرفع الصورة"}
                                            </span>
                                        </>
                                    ) : (
                                        <div className="relative w-full h-full">
                                            <img src={image} alt="الصورة الملتقطة" className="w-full h-full object-contain rounded-xl" />
                                            <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImage}>
                                                <MdOutlineDeleteOutline className="w-5 h-5" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <input type="file" name="logo" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChange}  />
                            </div>
                        </div>
                    </div>
            </div>
            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};